/* eslint-disable import/no-anonymous-default-export */
import environment from '../environments/Environment';
import HttpService from './HttpService';

export default {
    getPermissionList() {
        return HttpService.get(environment.API_PERMISSION);
    },
    getPermissionById(id) {
        return HttpService.get(environment.API_PERMISSION + '/' + id);
    },
    createdPermission(payload) {
        return HttpService.post(environment.API_PERMISSION, payload);
    },
    updatePermission(payload) {
        return HttpService.put(environment.API_PERMISSION, payload);
    },
    deletePermission(id) {
        return HttpService.delete(environment.API_PERMISSION + '/' + id);
    },
    getUserPermission() {
        return HttpService.get(environment.API_USER_PERMISSION);
    },
    getHistory(id) {
        return HttpService.get(environment.API_PERMISSION + '/history/' + id);
    }
};